import apiAxios from '@/services/axiosConfig';
import type { ConnectionsResponse } from '../type';

async function getConnections(): Promise<ConnectionsResponse> {
  const response = await apiAxios.get<ConnectionsResponse>('/api/v1/mt/connections');
  return response.data;
}

export default getConnections;
